<template>
	<form @submit.prevent="sendResetCode()" class="text-center">
		<h4 class="mb-3 f-w-400">Reset your password</h4>
		<div class="form-group mb-3">
			<label class="control-label" for="Email">Email address</label>
			<input
				v-model="form.email"
				type="text"
				class="form-control"
				id="Email"
				placeholder=""
				required
			/>
		</div>
		<div class="form-group">
			<LoadingButton
				class="btn btn-block btn-info mb-4"
				style="width: 100%; margin: 0"
				>Submit</LoadingButton
			>
			<p class="mb-0 text-muted">
				<a href="/login" class="f-w-400 text-primary">Back to login</a>
			</p>
		</div>
	</form>
</template>
<script>
import LoadingButton from "@/components/LoadingButton.vue";
import { mapActions } from "vuex";

export default {
	components: {
		LoadingButton,
	},

	data() {
		return {
			form: {
				email: null,
			},
		};
	},

	methods: {
		...mapActions({
			SendResetPasswordCode: "auth/SendResetPasswordCode",
		}),

		sendResetCode() {
			this.SendResetPasswordCode(this.form).then((response) => {
				if (response === "success") {
					this.$router
						.push("/reset-password")
						.then(() => {})
						// .then(() => location.reload())
						.catch(() => {});
				}
			});
		},
	},

	mounted() {
		this.$store.commit("shared/setErrorResponse", null);
	},
};
</script>
<style scoped>
.form-control {
	padding: 5px 10px;
}
</style>
